import breakpoints from '@/constants/breakpoints';
import React from 'react';
import styled from 'styled-components';
import Arrow from './arrow';

export default function RoundedArrow({ direction }) {
  return (
    <Rounded>
      <Arrow direction={direction} />
    </Rounded>
  );
}

const Rounded = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: ${props => props.theme.colors.limoncello};

  @media (min-width: ${breakpoints['large-desktop']}px) {
    width: 50px;
    height: 50px;
  }
`;